import { withBase } from 'ufo'

export type Variant = 'user' | 'project' | 'market-maker' | 'exchange'

/**
 * @deprecated Use the `@forgd/ui-kit/blocks/avatars` components instead; they carry their own fallbacks.
 */
export const FALLBACK_MM_IMAGE_URL = '/images/market-maker-logos/other.png'
/**
 * @deprecated Use the `@forgd/ui-kit/blocks/avatars` components instead; they carry their own fallbacks.
 */
export const FALLBACK_EXCHANGE_IMAGE_URL = '/images/market-maker-logos/exchange-other.jpg'
/**
 * @deprecated Use the `@forgd/ui-kit/blocks/avatars` components instead; they carry their own fallbacks.
 */
export const FALLBACK_PROJECT_IMAGE_URL = '/icons/project-placeholder-icon.svg'
export const FALLBACK_USER_IMAGE_URL = '/images/avatars/user.svg'

export function variantFallback(variant: Variant) {
  switch (variant) {
    case 'user':
      return FALLBACK_USER_IMAGE_URL
    case 'market-maker':
      return FALLBACK_MM_IMAGE_URL
    case 'exchange':
      return FALLBACK_EXCHANGE_IMAGE_URL
    case 'project':
    default:
      return FALLBACK_PROJECT_IMAGE_URL
  }
}

export function resolveSrc(variant: Variant, path?: string | null) {
  // we can only resolve paths if they're relative from the page
  if (path && (path.startsWith('http') || path.startsWith('/'))) {
    return path
  }
  if (!path) {
    return variantFallback(variant)
  }
  switch (variant) {
    case 'user':
    case 'project':
      return path
    case 'market-maker':
      return withBase(path, `/images/market-maker-logos/`)
    case 'exchange':
      return withBase(path, `/images/exchanges/`)
    default:
      return path || FALLBACK_PROJECT_IMAGE_URL
  }
}

/**
 * @deprecated Use the `@forgd/ui-kit/blocks/avatars` components instead; they carry their own fallbacks.
 */
export function resolveLogoWithFallback(variant: Variant, path?: string | null) {
  return resolveSrc(variant, path)
}

export function getPathWithoutProjectId(path: string) {
  if (path.startsWith('/project/')) {
    return `/${path.split('/').slice(3).join('/')}`
  }
  else {
    return path
  }
}
